module.exports = __webpack_public_path__ + "img/wallet.66b8433e.svg";